/**
 * custom-artamore.js — artamore 定制交互(独立于厂商文件,主题升级不覆盖)
 *
 * 1) 产品卡片色板悬停换图(恢复自升级前 theme.js 定制段,2026-08-19)
 *    Markup: snippets/card-product.liquid renders [data-swatch-wrapper] with
 *    [data-swatch] buttons carrying data-image / data-url. Hovering a swatch
 *    swaps the card's main image; clicking navigates to the variant.
 *    (2.3 card images carry srcset/sizes, so those attributes are cleared
 *    before assigning src — otherwise the browser keeps the srcset pick.)
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-product-card]').forEach((card) => {
    const img = card.querySelector('.product-card__image--main img');
    if (!img) return;

    const wrap = card.querySelector('[data-swatch-wrapper]');
    if (!wrap) return;

    const swatches = wrap.querySelectorAll('[data-swatch]');
    if (!swatches.length) return;

    // 默认 active 第一个
    swatches[0].classList.add('is-active');

    swatches.forEach((btn) => {
      btn.addEventListener('mouseenter', () => {
        const newSrc = btn.dataset.image;
        if (newSrc) {
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
          img.src = newSrc;
        }

        swatches.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });

      btn.addEventListener('click', () => {
        const url = btn.dataset.url;
        if (url) window.location.href = url;
      });
    });
  });
});
